import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
// import { reqToAddTenant } from "../redux/tenantSlice"; // Assume you have this
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../content/SidebarContent";
import PageHeader from "../../components/PageHeader";
import { reqToAddTenant } from "../../redux/slices.js/tenants/tenantsSlice";
import { routes } from "../../helpers/constants";
import Loader from "../../components/Loader";

const companyTypeOptions = [
  { value: "Private", label: "Private" },
  { value: "Public", label: "Public" },
  { value: "Startup", label: "Startup" },
];

const teamStrengthOptions = [
  { value: "1-10", label: "1-10" },
  { value: "11-50", label: "11-50" },
  { value: "51-200", label: "51-200" },
  { value: "200+", label: "200+" },
];

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is Required!"),
  name: Yup.string().required("Name is Required!"),
  companyName: Yup.string().required("Company Name is Required!"),
  companyType: Yup.object().required("Comapny Type is Required!"),
  teamStrength: Yup.object().required("Team Strength is Required!"),
});

const AddTenant = () => {
  const { setIsSidebarOpen } = useSidebar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = useSelector((state) => state.tenants.loader);

  const initialValues = {
    email: "",
    name: "",
    companyName: "",
    companyType: null,
    teamStrength: null,
  };

  const handleSubmit = (values, { resetForm }) => {
    dispatch(
      reqToAddTenant({
        data: {
          email: values.email,
          admin_name: values.name,
          company_name: values.companyName,
          company_type: values.companyType.value,
          team_strength: values.teamStrength.value,
        },
        onSuccess: () => {
          resetForm();
          navigate(routes.tenantAddedSuccess);
        },
        onFailure: () => {},
      })
    );
  };

  return (
    <>
    {loader && <Loader />}
    <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
      <div className="!p-0">
        <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
          <PageHeader
            title="Add Tenant"
            description="Create a new tenant profile for your organization."
            onOpenSidebar={() => setIsSidebarOpen(true)}
          />

          <div className="flex items-baseline gap-[40px] main-sidebar-wrapper flex-1">
            <div className="flex-1 right-sidebar h-full relative">
              <div className="right-sidebar-contend py-6 px-3 md:px-6 pb-[50px] h-full">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, setFieldValue, touched, errors }) => (
                    <Form className="signin-form flex flex-col gap-6">
                      <div className="bg-white box-shadow p-5 space-y-7 rounded-md">
                        <h2 className="text-h4 text-blue">
                          Tenant Information
                        </h2>

                        <div className="grid md:grid-cols-2 gap-6">
                          <div>
                            <label htmlFor="email">
                              Email <span>*</span>
                            </label>
                            <Field
                              name="email"
                              type="email"
                              placeholder="Enter email"
                              className="w-full"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>

                          <div>
                            <label htmlFor="name">
                              Admin Name <span>*</span>
                            </label>
                            <Field
                              name="name"
                              placeholder="Enter your name"
                              className="w-full"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>

                          <div>
                            <label htmlFor="companyName">
                              Company Name <span>*</span>
                            </label>
                            <Field
                              name="companyName"
                              placeholder="Enter company name"
                              className="w-full"
                            />
                            <ErrorMessage
                              name="companyName"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>

                          <div>
                            <label htmlFor="companyType">
                              Company Type <span>*</span>
                            </label>
                            <Select
                              name="companyType"
                              placeholder="Select company type"
                              options={companyTypeOptions}
                              value={values.companyType}
                              onChange={(option) =>
                                setFieldValue("companyType", option)
                              }
                              className="react-select-container w-full"
                              classNamePrefix="react-select"
                              isClearable={false}
                              isSearchable={false}
                            />
                            {errors.companyType && touched.companyType && (
                              <div className="text-red-500 text-sm mt-1">
                                {errors.companyType}
                              </div>
                            )}
                          </div>

                          <div>
                            <label htmlFor="teamStrength">
                              Team Strength <span>*</span>
                            </label>
                            <Select
                              name="teamStrength"
                              placeholder="Select team strength"
                              options={teamStrengthOptions}
                              value={values.teamStrength}
                              onChange={(option) =>
                                setFieldValue("teamStrength", option)
                              }
                              className="react-select-container w-full"
                              classNamePrefix="react-select"
                              isClearable={false}
                              isSearchable={false}
                            />
                            {errors.teamStrength && touched.teamStrength && (
                              <div className="text-red-500 text-sm mt-1">
                                {errors.teamStrength}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex gap-4 mt-auto">
                        <button type="submit" className="login-btn text-white">
                          Submit
                        </button>
                        <button
                          type="button"
                          className="skip-btn border-blue"
                          onClick={() => navigate(-1)}
                        >
                          Back
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AddTenant;
